import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// ==================== AUTH ====================
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};
export const isUserAuthenticated = () => getLoggedInUser() !== null;

export const postLogin = (data: any) =>
  api.createFormUrlEncoded(url.LOGIN, data);
export const getToken = () => api.get(url.GET_TOKEN);
export const getTokenSuperadmin = () => api.get(url.SUPERADMIN_GET_TOKEN);
export const adminChangePassword = (data: any) =>
  api.put(url.ADMIN_CHANGE_PASSWORD, data);
export const adminChangePasswordFirstLogin = (data: any) =>
  api.put(url.ADMIN_CHANGE_PASSWORD_FIRST_LOGIN, data);

// ==================== ADMIN COMBO ====================
export const adminGetComboMember = (param: any) =>
  api.get(url.ADMIN_GET_COMBO_MEMBER, param);
export const adminGetComboShift = () => api.get(url.ADMIN_GET_COMBO_SHIFT);
export const adminGetComboPatrol = (param: any) =>
  api.get(url.ADMIN_GET_COMBO_PATROL, param);
export const adminGetComboSalary = () => api.get(url.ADMIN_GET_COMBO_SALARY);
export const adminGetComboInsurance = () =>
  api.get(url.ADMIN_GET_COMBO_INSURANCE);
export const adminGetComboBenefit = () => api.get(url.ADMIN_GET_COMBO_BENEFIT);
export const adminGetComboDeduction = () =>
  api.get(url.ADMIN_GET_COMBO_DEDUCTION);

// ==================== ADMIN ACCOUNT ====================
export const adminGetAllAdmins = (param: any) =>
  api.get(url.ADMIN_GET_ALL_ADMINS, param);
export const adminCreateAdmin = (data: any) =>
  api.create(url.ADMIN_CREATE_ADMIN, data);
export const adminGetAdminById = (id: any) =>
  api.get(url.ADMIN_GET_ADMIN_BY_ID.replace("{id}", id));
export const adminUpdateAdmin = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_ADMIN.replace("{id}", id), data);
export const adminDeleteAdminById = (id: any) =>
  api.delete(url.ADMIN_DELETE_ADMIN_BY_ID.replace("{id}", id), id);
export const adminGetAdminExcel = () => api.get(url.ADMIN_GET_ADMIN_EXCEL);

// ==================== ADMIN MEMBER ====================
export const adminGetAllMembers = (param: any) =>
  api.get(url.ADMIN_GET_ALL_MEMBERS, param);
export const adminCreateMember = (data: any) =>
  api.createFormData(url.ADMIN_CREATE_MEMBER, data);
export const adminGetMemberById = (id: any) =>
  api.get(url.ADMIN_GET_MEMBER_BY_ID.replace("{id}", id));
export const adminUpdateMember = (id: any, data: any) =>
  api.putFormData(url.ADMIN_UPDATE_MEMBER.replace("{id}", id), data);
export const adminDeleteMemberById = (id: any) =>
  api.delete(url.ADMIN_DELETE_MEMBER_BY_ID.replace("{id}", id), id);
export const adminResetMemberPassword = (id: any, data: any) =>
  api.put(url.ADMIN_RESET_MEMBER_PASSWORD.replace("{id}", id), data);
export const adminGetAllMembersExcel = () =>
  api.getBlob(url.ADMIN_GET_ALL_MEMBERS_EXCEL);
export const adminGetComboWorkLocation = () =>
  api.get(url.ADMIN_COMBO_WORK_LOCATION);
export const adminCountAllMember = () => api.get(url.ADMIN_COUNT_ALL_MEMBER);
export const adminUploadMember = (data: any) =>
  api.createFormData(url.ADMIN_UPLOAD_MEMBER, data);
export const adminUploadProfilePictures = (data: any) =>
  api.createFormData(url.ADMIN_UPLOAD_PROFILE_PICTURES, data);

// ==================== ADMIN WORK LOCATION ====================
export const adminGetAllWorkLocation = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_WORK_LOCATION, param);
export const adminCreateWorkLocation = (data: any) =>
  api.create(url.ADMIN_CREATE_WORK_LOCATION, data);
export const adminGetWorkLocationById = (id: any) =>
  api.get(url.ADMIN_GET_WORK_LOCATION_BY_ID.replace("{id}", id));
export const adminUpdateWorkLocation = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_WORK_LOCATION.replace("{id}", id), data);
export const adminDeleteWorkLocationById = (id: any) =>
  api.delete(url.ADMIN_DELETE_WORK_LOCATION_BY_ID.replace("{id}", id), id);

// ==================== ADMIN SHIFT ====================
export const adminGetAllShift = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_SHIFT, param);
export const adminCreateShift = (data: any) =>
  api.create(url.ADMIN_CREATE_SHIFT, data);
export const adminUpdateShift = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_SHIFT.replace("{id}", id), data);
export const adminUpdateStatusShift = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_STATUS_SHIFT.replace("{id}", id), data);
export const adminGetShiftById = (id: any) =>
  api.get(url.ADMIN_GET_SHIFT_BY_ID.replace("{id}", id));
export const adminDeleteShiftById = (id: any) =>
  api.delete(url.ADMIN_DELETE_SHIFT_BY_ID.replace("{id}", id), id);
export const adminGenerateCheckoutQrCode = (id: any, data: any) =>
  api.put(url.ADMIN_GENERATE_CHECKOUT_QR_CODE.replace("{id}", id), data);

// ==================== ADMIN OVERTIME ====================
export const adminGetAllOvertime = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_OVERTIME, param);

// ==================== ADMIN PATROL ====================
export const adminGetAllPatrol = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_PATROL, param);
export const adminGetAllPatrolExcel = (param?: any) =>
  api.getBlob(url.ADMIN_GET_ALL_PATROL_EXCEL, param);

// ==================== ADMIN PATROL LOCATION ====================
export const adminGetAllPatrolLocation = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_PATROL_LOCATION, param);
export const adminCreatePatrolLocation = (data: any) =>
  api.create(url.ADMIN_CREATE_PATROLL_LOCATION, data);
export const adminGetPatrolLocationById = (id: any) =>
  api.get(url.ADMIN_GET_PATROL_LOCATION_BY_ID.replace("{id}", id));
export const adminUpdatePatrolLocation = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_PATROL_LOCATION.replace("{id}", id), data);
export const adminDeletePatrolLocationById = (id: any) =>
  api.delete(url.ADMIN_DELETE_PATROL_LOCATION_BY_ID.replace("{id}", id), id);

// ==================== ADMIN NOTIFICATION ====================
export const adminGetAllNotif = (param: any) =>
  api.get(url.ADMIN_GET_ALL_NOTIF, param);

// ==================== ADMIN ATTENDANCE ====================
export const adminGetAllAttendance = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_ATTENDANCE, param);
export const adminGetAllAttendanceExcel = (param?: any) =>
  api.getBlob(url.ADMIN_GET_ALL_ATTENDANCE_EXCEL, param);

// ==================== ADMIN EVENT ====================
export const adminGetAllEvents = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_EVENTS, param);
export const adminCreateEvent = (data: any) =>
  api.create(url.ADMIN_CREATE_EVENT, data);
export const adminGetEventById = (id: any) =>
  api.get(url.ADMIN_GET_EVENT_BY_ID + id);
export const adminUpdateEvent = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_EVENT.replace("{id}", id), data);
export const adminDeleteEventById = (id: any) =>
  api.delete(url.ADMIN_DELETE_EVENT_BY_ID.replace("{id}", id), id);
export const adminGetEventAttendance = (id: any, param?: any) =>
  api.get(url.ADMIN_GET_EVENT_ATTENDANCE.replace("{id}", id), param);
export const adminGetEventAttendanceExcel = (id: any) =>
  api.get(url.ADMIN_GET_EVENT_ATTENDANCE_EXCEL.replace("{id}", id));

// ==================== ADMIN ATTENDANCE BY PHOTO ====================
export const adminGetAllAttendanceByPhoto = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_ATTENDANCE_BY_PHOTO, param);
export const adminGetAllAttendanceByPhotoExcel = (param?: any) =>
  api.getBlob(url.ADMIN_GET_ALL_ATTENDANCE_BY_PHOTO_EXCEL, param);

// ==================== ADMIN MENU ====================
export const adminGetAdminMenus = () => api.get(url.ADMIN_GET_ADMIN_MENUS);
export const adminGetComboMemberMenus = () =>
  api.get(url.ADMIN_GET_COMBO_MEMBER_MENUS);
export const adminGetMemberMenus = () => api.get(url.ADMIN_GET_MEMBER_MENUS);
export const adminUpdateMemberMenus = (data: any) =>
  api.put(url.ADMIN_UPDATE_MEMBER_MENUS, data);

// ==================== ADMIN COMPANY ====================
export const adminGetCompanyDetail = () =>
  api.get(url.ADMIN_GET_COMPANY_DETAIL);
export const adminUpdateCompany = (data: any) =>
  api.putFormData(url.ADMIN_UPDATE_COMPANY, data);
export const adminGetCompanySettingById = () =>
  api.get(url.ADMIN_GET_COMPANY_SETTING_BY_ID);

// ==================== ADMIN WORK EXTENSION ====================
export const adminGetAllWorkExtension = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_WORK_EXTENSION, param);
export const adminGetAllWorkExtensionsExcel = () =>
  api.get(url.ADMIN_GET_ALL_WORK_EXTENSIONS_EXCEL);
export const adminUpdateWorkExtensionStatus = (id: any, data: any) =>
  api.put(
    url.ADMIN_UPDATE_WORK_EXTENSION_STATUS.replace("{idWorkExtension}", id),
    data,
  );

// ==================== ADMIN NEWS ====================
export const adminGetListNews = (param?: any) =>
  api.get(url.ADMIN_GET_LIST_NEWS, param);
export const adminAddNews = (data: any) => api.create(url.ADMIN_ADD_NEWS, data);
export const adminGetNewsById = (id: any) =>
  api.get(url.ADMIN_GET_NEWS_BY_ID.replace("{id}", id));
export const adminUpdateNewsById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_NEWS_BY_ID.replace("{id}", id), data);
export const adminDeleteNewsById = (id: any) =>
  api.delete(url.ADMIN_DELETE_NEWS_BY_ID.replace("{id}", id));

// ==================== ADMIN PAYSLIP ====================
export const adminGetAllPayslip = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_PAYSLIP, param);
export const adminGetPayslipById = (id: any) =>
  api.get(url.ADMIN_GET_PAYSLIP_BY_ID.replace("{id}", id));
export const adminCreatePayslip = (data: any) =>
  api.create(url.ADMIN_CREATE_PAYSLIP, data);
export const adminUpdatePayslipById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_PAYSLIP_BY_ID.replace("{id}", id), data);
export const adminDeletePayslipById = (id: any) =>
  api.delete(url.ADMIN_DELETE_PAYSLIP_BY_ID.replace("{id}", id));
export const adminDownloadPayslipPdfById = (id: any) =>
  api.getBlob(url.ADMIN_DOWNLOAD_PDF_BY_ID.replace("{id}", id));
export const adminUploadPayslip = (data: any) =>
  api.createFormData(url.ADMIN_UPLOAD_PAYSLIP, data);
export const adminDownloadTemplatePayslip = () => api.getBlob(url.ADMIN_DOWNLOAD_PAYSLIP_TEMPLATE_EXCEL);
export const adminDownloadPayslipExcel = (param?: any) => api.getBlob(url.ADMIN_DOWNLOAD_PAYSLIP_EXCEL, param);
export const adminDownloadPayslipZip = (param?: any) => api.getBlob(url.ADMIN_DOWNLOAD_PAYSLIP_ZIP, param);
export const adminBulkPublishPayslip = (data: any) =>
  api.put(url.ADMIN_BULK_PUBLISH_PAYSLIP, data);

// ==================== ADMIN SALARY ====================
export const adminGetAllSalary = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_SALARY, param);
export const adminCreateSalary = (data: any) =>
  api.create(url.ADMIN_CREATE_SALARY, data);
export const adminGetSalaryById = (id: any) =>
  api.get(url.ADMIN_GET_SALARY_BY_ID.replace("{id}", id));
export const adminUpdateSalaryById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_SALARY_BY_ID.replace("{id}", id), data);
export const adminDeleteSalaryById = (id: any) =>
  api.delete(url.ADMIN_DELETE_SALARY_BY_ID.replace("{id}", id));

// ==================== ADMIN INSURANCE ====================
export const adminGetAllInsurance = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_INSURANCE, param);
export const adminCreateInsurance = (data: any) =>
  api.create(url.ADMIN_CREATE_INSURANCE, data);
export const adminGetInsuranceById = (id: any) =>
  api.get(url.ADMIN_GET_INSURANCE_BY_ID.replace("{id}", id));
export const adminUpdateInsuranceById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_INSURANCE_BY_ID.replace("{id}", id), data);
export const adminDeleteInsuranceById = (id: any) =>
  api.delete(url.ADMIN_DELETE_INSURANCE_BY_ID.replace("{id}", id));

// ==================== ADMIN BENEFIT ====================
export const adminGetAllBenefit = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_BENEFIT, param);
export const adminCreateBenefit = (data: any) =>
  api.create(url.ADMIN_CREATE_BENEFIT, data);
export const adminGetBenefitById = (id: any) =>
  api.get(url.ADMIN_GET_BENEFIT_BY_ID.replace("{id}", id));
export const adminUpdateBenefitById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_BENEFIT_BY_ID.replace("{id}", id), data);
export const adminDeleteBenefitById = (id: any) =>
  api.delete(url.ADMIN_DELETE_BENEFIT_BY_ID.replace("{id}", id));

// ==================== ADMIN DEDUCTION ====================
export const adminGetAllDeduction = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_DEDUCTION, param);
export const adminCreateDeduction = (data: any) =>
  api.create(url.ADMIN_CREATE_DEDUCTION, data);
export const adminGetDeductionById = (id: any) =>
  api.get(url.ADMIN_GET_DEDUCTION_BY_ID.replace("{id}", id));
export const adminUpdateDeductionById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_DEDUCTION_BY_ID.replace("{id}", id), data);
export const adminDeleteDeductionById = (id: any) =>
  api.delete(url.ADMIN_DELETE_DEDUCTION_BY_ID.replace("{id}", id));

// ==================== ADMIN LOG VEHICLE ====================
export const adminGetAllLogVehicle = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_LOG_VEHICLE, param);
export const adminDownloadLogVehicleExcel = (param?: any) =>
  api.getBlob(url.ADMIN_LOG_VEHICLE_EXCEL, param);
export const adminGetLogVehicleById = (id: any) =>
  api.get(url.ADMIN_GET_LOG_VEHICLE_BY_ID.replace("{id}", id));

// ==================== ADMIN LOG PRODUCT ====================
export const adminGetAllLogProduct = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_LOG_PRODUCT, param);
export const adminDownloadLogProductExcel = (param?: any) =>
  api.getBlob(url.ADMIN_LOG_PRODUCT_EXCEL, param);
export const adminGetLogProductById = (id: any) =>
  api.get(url.ADMIN_GET_LOG_PRODUCT_BY_ID.replace("{id}", id));

// ==================== ADMIN INFO ====================
export const adminGetAllInfo = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_INFO, param);
export const adminCreateInfo = (data: any) =>
  api.create(url.ADMIN_CREATE_INFO, data);
export const adminGetInfoById = (id: any) =>
  api.get(url.ADMIN_GET_INFO_BY_ID.replace("{id}", id), true);
export const adminUpdateInfoById = (id: any, data: any) =>
  api.put(url.ADMIN_UPDATE_INFO_BY_ID.replace("{id}", id), data);
export const adminDeleteInfoById = (id: any) =>
  api.delete(url.ADMIN_DELETE_INFO_BY_ID.replace("{id}", id));

// ==================== ADMIN IMAGE ====================
export const adminGetImage = (nameFile: string) =>
  api.get(url.ADMIN_GET_IMAGE.replace("{nameFile}", nameFile));
export const adminUploadImage = (data: any, params?: any) => {
  if (params) {
    const queryString = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");

    return api.createFormData(`${url.ADMIN_UPLOAD_IMAGE}?${queryString}`, data);
  }
  return api.createFormData(url.ADMIN_UPLOAD_IMAGE, data);
};

// ==================== ADMIN DASHBOARD ====================
export const adminGetDashboardAttendance = async (param: any) => {
  const response = await api.get(url.ADMIN_DASHBOARD_ATTENDANCE, param);
  // Jika response sudah di-extract jadi array, wrap kembali dengan summary
  // Tapi karena summary hilang, kita perlu akses raw response
  return response;
};

// ==================== ADMIN DOCUMENTS ====================
export const adminGetCompanyDocuments = (param?: any) =>
  api.get(url.ADMIN_GET_COMPANY_DOCUMENTS, param);

// ==================== ADMIN COLLABORATION HISTORY ====================
export const adminGetAllCollaborationHistory = (param?: any) =>
  api.get(url.ADMIN_GET_ALL_COLLABORATION_HISTORY, param);  

export const adminGetDashboardAttendanceByPhoto = async (param: any) => {
  const response = await api.get(
    url.ADMIN_DASHBOARD_ATTENDANCE_BY_PHOTO,
    param,
  );
  return response;
};
// ==================== SUPERADMIN ACCOUNT ====================
export const superadminGetChangeCompany = (companyId: any) =>
  api.get(url.SUPERADMIN_GET_CHANGE_COMPANY.replace("{companyId}", companyId));
export const superadminGetComboCompany = (param?: any) =>
  api.get(url.SUPERADMIN_GET_COMBO_COMPANY, param);

// ==================== SUPERADMIN COMPANY ====================
export const superadminGetComboMenuAdmin = () =>
  api.get(url.SUPERADMIN_GET_COMBO_MENU_ADMIN);
export const superadminGetCompanyList = (param?: any) =>
  api.get(url.SUPERADMIN_GET_COMPANY_LIST, param);
export const superadminCreateCompany = (data: any) =>
  api.createFormData(url.SUPERADMIN_CREATE_COMPANY, data);
export const superadminUpdateCompany = (companyId: any, data: any) =>
  api.putFormData(
    url.SUPERADMIN_UPDATE_COMPANY.replace("{companyId}", companyId),
    data,
  );
export const superadminGetCompanyById = (idCompany: any) =>
  api.get(url.SUPERADMIN_GET_COMPANY_BY_ID.replace("{idCompany}", idCompany));
export const superadminDeleteCompany = (idCompany: any) =>
  api.delete(url.SUPERADMIN_DELETE_COMPANY.replace("{idCompany}", idCompany));
export const superadminGetCompanySettingById = (idCompany: any) =>
  api.get(
    url.SUPERADMIN_GET_COMPANY_SETTING_BY_ID.replace("{idCompany}", idCompany),
  );
export const superadminPostCompanySettingById = (data: any) =>
  api.createFormUrlEncoded(url.SUPERADMIN_POST_COMPANY_SETTING_BY_ID, data);

// ==================== SUPERADMIN NOTIFICATION ====================
export const superadminGetAllNotif = (param?: any) =>
  api.get(url.SUPERADMIN_GET_ALL_NOTIF, param);

export const getCompanyByInitial = (param?: any) =>
  api.get(url.GET_COMPANY_BY_INITIAL.replace("{initial}", param));

// ===================== SUPERADMIN COMPANY DOCUMENT ===============
export const superadminGetAllCompanyDocuments = (param?: any) =>
  api.get(url.SUPERADMIN_GET_COMPANY_DOCUMENTS, param);
export const superadminCreateCompanyDocuments = (data: any) =>
  api.createFormData(
    url.SUPERADMIN_CREATE_COMPANY_DOCUMENTS,
    data,
  );
export const superadminUpdateCompanyDocuments = (
  id: any,
  data: any,
) =>
  api.putFormData(
    url.SUPERADMIN_UPDATE_COMPANY_DOCUMENTS.replace("{documentId}", id),
    data,
  );
export const superadminDeleteCompanyDocuments = (id: any) =>
  api.delete(url.SUPERADMIN_DELETE_COMPANY_DOCUMENTS.replace("{id}", id));

// ===================== SUPERADMIN COLLABORATION HISTORY ==========
export const superadminGetAllCollaborationHistory = (param?: any) =>
  api.get(url.SUPERADMIN_GET_ALL_COLLABORATION_HISTORY, param);
export const superadminGetByIdCollaborationHistory = (id: any) =>
  api.get(
    url.SUPERADMIN_GET_BY_ID_COLLABORATION_HISTORY.replace("{historyId}", id),
  );
export const superadminCreateCollaborationHistory = (data: any) =>
  api.createFormData(
    url.SUPERADMIN_CREATE_COLLABORATION_HISTORY,
    data,
  );
export const superadminUpdateCollaborationHistory = (
  id: any,
  data: any,
) =>
  api.putFormData(
    url.SUPERADMIN_UPDATE_COLLABORATION_HISTORY.replace("{historyId}", id),
    data,
  );
export const superadminDeleteCollaborationHistory = (id: any) =>
  api.delete(
    url.SUPERADMIN_DELETE_COLLABORATION_HISTORY.replace("{historyId}", id),
  );
